// extracted by mini-css-extract-plugin
export default {"dialog":"CouponExpiredDialog_dialog__YOBEf","icon":"CouponExpiredDialog_icon__QwftH","formButton":"CouponExpiredDialog_formButton__kPID3"};